import m from 'mithril'
import passwordValidator 			from 'password-validator'
import {AuthenticationDetails, CognitoUserPool, CognitoUser, CookieStorage} from 'amazon-cognito-identity-js'
// import * as AWS from 'aws-sdk/global'


// Inlined during create server in the bundle generation file
const COGNITO_USER_POOL_ID = window.COGNITO_USER_POOL_ID
const COGNITO_CLIENT_ID = window.COGNITO_CLIENT_ID

const cookie_domain = window.location.hostname
const pool_data = {
	UserPoolId: COGNITO_USER_POOL_ID,
	ClientId: COGNITO_CLIENT_ID,
	Storage: new CookieStorage({ domain: cookie_domain, secure: window.location.protocol === 'https:', sameSite: 'lax' }),
}
const user_pool = new CognitoUserPool(pool_data)

let cognito_user



export const getSession = () => new Promise((resolve, reject) => {

	const cognito_user = user_pool.getCurrentUser()

	if(!cognito_user) return resolve()

	cognito_user.getSession(function(error, session) {
		if (error) {
			console.log(error)
			return reject(error.message)
		}

		// The Cognito SDK auto-refreshes the access token (via the refresh token) when it has
		// expired, before this callback fires. Trust that session instead of treating a still-valid
		// token as expired within a fixed buffer, which logged users out near expiry (e.g. after a publish).
		resolve({
			access_token: session.getAccessToken().getJwtToken(),
			id_token: session.getIdToken().getJwtToken(),
			is_expired: false,
		})
	})
	
})


getSession().then(session => {
	return
})


export const getUser = () => {

	// console.log('GET USER', cognito_user)
	return cognito_user
}

export const signOut = (query=null) => {
	// console.log('Signing user out')
	window.dispatchEvent(new Event('flowlabs:signout'))

	const cognito_user = user_pool.getCurrentUser()
	if (cognito_user !== null) cognito_user.signOut()

	m.request({
		url: '/api/v1/signout',
		method: "POST",
		body: {},
	}).then(res => {
		// console.log(res)
	})

	if (query) {
		
		window.location.href = '/auth/login' + '?' +  m.buildQueryString(query)
	}
	else {
		window.location.href = '/auth/login'
	}
	
}



// Only hand the user's Cognito tokens to a trusted Flow MCP origin (the Option B OAuth handoff).
// This prevents a crafted ?mcp_origin=evil.com login link from exfiltrating tokens after sign-in.
const isAllowedMcpOrigin = (origin) => {
	if (!origin) return false
	if (origin === 'http://localhost:3100') return true
	try {
		const url = new URL(origin)
		// Trusted Flow MCP public hostnames: atlas-mcp.<...>.flowlabs.(com|info),
		// plus the bare mcp / mcp-staging hosts (mcp.flowlabs.info = prod cutover,
		// mcp-staging.flowlabs.info = the flow-mcp staging environment).
		if (url.protocol === 'https:' && /^(atlas-mcp\.[a-z0-9.-]*|mcp(-staging)?\.)flowlabs\.(com|info)$/.test(url.hostname)) return true
		// Dev only: when the app itself is served from localhost, allow ngrok/cloudflare tunnels so
		// the Claude connector flow can be tested end-to-end through a tunnel. Gated on a localhost
		// host, so this can NEVER activate in production (served from dashboard.flowlabs.*).
		const host = window.location.hostname
		const is_local_dev = host === 'localhost' || host === '127.0.0.1'
		if (is_local_dev && url.protocol === 'https:' && /\.(ngrok(-free)?\.(app|io|dev)|trycloudflare\.com)$/.test(url.hostname)) return true
		return false
	} catch {
		return false
	}
}

export const login = async (email, password) => new Promise((resolve, reject) => {

	var authenticationData = {
        Username: email,
        Password: password,
    }

    var authenticationDetails = new AuthenticationDetails(authenticationData)
    
    var userData = {
        Username: email,
        Pool: user_pool,
    }
    
    cognito_user = new CognitoUser(userData)


    cognito_user.authenticateUser(authenticationDetails, {
        onSuccess: function(session) {

        	// console.log(session, session.getAccessToken().getJwtToken(), session.getIdToken().getJwtToken(), session.getIdToken().getJwtToken(), session.getRefreshToken().getToken())

			var token = session.getAccessToken().getJwtToken()

			m.request({
				url: '/api/v1/login',
				method: "POST",
				body: {
					id_token: session.getIdToken().getJwtToken(),
					access_token: session.getAccessToken().getJwtToken(),
					refresh_token: session.getRefreshToken().getToken(),
				}
			})
    		.then(async response => {
				// Option B: if this login was launched by the Claude/MCP connector (flow-mcp
				// redirected here with mcp_oauth + mcp_origin), mint a wrapped, revocable AI session
				// token IN atlas-ui and hand flow-mcp ONLY that token — never the raw Cognito tokens.
				// Claude (via flow-mcp) thus only ever holds the wrapped, attributable, instantly
				// revocable credential. The browser keeps its own Cognito session (it IS the user).
				try {
					const params = new URLSearchParams(window.location.search)
					const mcp_origin = params.get('mcp_origin')
					const mcp_oauth = params.get('mcp_oauth')
					if (mcp_origin && mcp_oauth && isAllowedMcpOrigin(mcp_origin)) {
						const mintRes = await fetch('/api/v2/auth/ai-session', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'Authorization': `Bearer ${session.getAccessToken().getJwtToken()}`,
							},
							body: JSON.stringify({ app: 'claude-mcp', name: 'claude-mcp' }),
						})
						const mintData = await mintRes.json().catch(() => ({}))
						if (!mintRes.ok || !mintData?.token) {
							reject('Could not create a secure connector session. Please try again.')
							return
						}
						const res = await fetch(`${mcp_origin}/oauth/complete`, {
							method: 'POST',
							headers: {'Content-Type': 'application/json'},
							body: JSON.stringify({
								k: mcp_oauth,
								ai_session_token: mintData.token,
								expires_at: mintData.expires_at ? new Date(mintData.expires_at).getTime() : undefined,
							}),
						})
						const data = await res.json().catch(() => ({}))
						if (res.ok && data?.ok && data.callbackUrl) {
							window.location.href = data.callbackUrl
							return
						}
						reject(data?.error || 'Could not complete the connector sign-in. Please try again.')
						return
					}
					resolve(token)
				} catch (err) {
					reject('Could not reach the connector to complete sign-in.')
				}
    		})


        },
        newPasswordRequired: function (userAttributes, requiredAttributes) {
	        m.route.set('/auth/password')
	        resolve()
	    },
        onFailure: function(error) {
            // console.log('Authentication failed', error)

			reject(error?.message || 'There was a problem logging in.')

			
        },
    })
})



const schema = new passwordValidator()

schema
.is().min(8, 'Minimum of 8 characters')
.is().max(99, 'Maximum of 99 characters')
.has().digits(1, 'Contains at least 1 number')
.has().uppercase(1, 'Contains at least 1 uppercase letter')
.has().lowercase(1, 'Contains at least 1 lowercase letter')
.has().symbols(1, 'Contains at least 1 special character')


export const validatePassword = (password_1, password_2) => {

	if(!password_1) return 'Password is required'

	password_1 = (password_1 || '').trim()
	password_2 = (password_2 || '').trim()

	if(password_1 != password_2) return 'Passwords do not match'

	const error_details = schema.validate(password_1, { details: true })

	// console.log(error_details)

	return error_details.map(x => x.message).join('\n')
}


export const reset = (email, verification_code, new_password) => new Promise((resolve, reject) => {

	var userData = {
        Username: email,
        Pool: user_pool,
    }
    
    cognito_user = new CognitoUser(userData)

	cognito_user.confirmPassword(verification_code, new_password, {
        onSuccess: async function(session) {
        	
        	await login(email, new_password)
        	
          	resolve()
        },
        onFailure: function(error) {
        	console.error(error)
        	reject(error.message)
        }
    })
})

export const newPassword = (cognito_user, new_password) => new Promise((resolve, reject) => {
	cognito_user.completeNewPasswordChallenge(new_password, {}, {
        onSuccess: function(session) {
          	resolve(session)
        },
        onFailure: function(error) {
        	console.error(error)
        	reject(error.message)
        }
    })
})

export const changePassword = (current_password, new_password) => new Promise((resolve, reject) => {

    const cognito_user = user_pool.getCurrentUser()

	// need to call getSession() first so that the user is authenticated
    cognito_user.getSession(function (err, session) {
        cognito_user.changePassword(current_password, new_password, function(err, result) {
            if (err) {                                           	
				reject(err.name || JSON.stringify(err))
    	    }else{
			    resolve()
			}
        })
    })
})


export const forgot = (email) => new Promise((resolve, reject) => {

	const userData = {
        Username: email,
        Pool: user_pool,
    }

    cognito_user = new CognitoUser(userData)

	cognito_user.forgotPassword({
        onSuccess: function(session) {
          	m.route.set('/auth/reset', {email: email})
        },
        onFailure: function(error) {
        	console.error(error)
        	reject(error.message)
        },
    })
})
